module.exports = __webpack_public_path__ + "static/img/logo.73545940.png";